import { useEffect } from "react";
import { leadAllianceTracking } from "utils/ad-network";
import { getCookie } from "utils/cookie";
import { getLeadAllianceProgramId } from "utils/site";
import { inProduction } from "../../../../config";

const INSTANCE_URL = "https://eur.partner.lassie.co/tl.php";

export const useLeadAllianceTrackingQpTracking = ({
  orderId,
}: {
  orderId: string;
}) => {
  useEffect(() => {
    let img: HTMLImageElement | null;

    const programId = getLeadAllianceProgramId();

    if (programId && inProduction) {
      const lea_source_pc = getCookie(leadAllianceTracking.cookieName);

      if (!lea_source_pc) {
        return;
      }

      const qp = new URLSearchParams();

      qp.set("p", programId);
      qp.set("oid", orderId);
      qp.set("lea_source_pc", lea_source_pc);
      qp.set("ovalue", "0");
      qp.set("ocategory", "all-lead");

      img = document.createElement("img");

      img.src = `${INSTANCE_URL}?${qp.toString()}`;
      img.alt = "";
      img.width = 0;
      img.height = 0;

      document.body.appendChild(img);
    }

    return () => {
      if (img) {
        document.body.removeChild(img);
      }
    };
  }, [orderId]);
};
